export default "__VITE_ASSET__DwjGpWaC__"